/* Pacem wishlist (client, 2026-09-28).

   A signed-in customer's saved pieces, kept in this browser's localStorage
   under their customer id, so each account on a shared device has its own
   list. Guests can't save: the heart takes them to /pages/wishlist, which asks
   them to sign in. Config comes from window.pacemWishlist, set in theme.liquid.

   Markup hooks:
   - [data-pacem-wishlist="<handle>"]  a heart that toggles that product
   - [data-pacem-wishlist-grid]        the wishlist page's product grid
   - [data-pacem-wishlist-empty]       shown when the list is empty */
(function () {
  var config = window.pacemWishlist || {};
  var customerId = config.customerId;
  var pageUrl = config.pageUrl || '/pages/wishlist';
  var storageKey = customerId ? 'pacem:wishlist:' + customerId : null;

  function read() {
    if (!storageKey) return [];
    try {
      var list = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(list));
    } catch (e) {}
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-pacem-wishlist]').forEach(function (button) {
      var saved = list.indexOf(button.dataset.pacemWishlist) !== -1;
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  function toggle(handle) {
    var list = read();
    var index = list.indexOf(handle);
    if (index === -1) list.unshift(handle);
    else list.splice(index, 1);
    write(list);
    syncButtons();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pacem-wishlist]');
    if (button) {
      event.preventDefault();
      if (!customerId) {
        window.location.href = pageUrl;
        return;
      }
      toggle(button.dataset.pacemWishlist);
      return;
    }

    var remove = event.target.closest('[data-pacem-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      toggle(remove.dataset.pacemWishlistRemove);
      renderGrid();
    }
  });

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: config.currency || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function card(product) {
    var image = product.featured_image
      ? '<img class="pacem-wishlist__image" src="' + product.featured_image + '&width=600" alt="' +
        escapeHtml(product.title) + '" loading="lazy" width="600" height="600">'
      : '';
    return (
      '<li class="pacem-wishlist__item">' +
      '<a class="pacem-wishlist__link" href="' + product.url + '">' + image +
      '<div class="pacem-wishlist__title">' + escapeHtml(product.title) + '</div>' +
      '<div class="pacem-wishlist__price">' + formatMoney(product.price) + '</div>' +
      '</a>' +
      '<button type="button" class="pacem-wishlist__remove" data-pacem-wishlist-remove="' +
      escapeHtml(product.handle) + '">Remove</button>' +
      '</li>'
    );
  }

  function renderGrid() {
    var grid = document.querySelector('[data-pacem-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-pacem-wishlist-empty]');
    var list = read();

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var found = products.filter(Boolean);
      // Drop pieces that no longer exist so the list doesn't keep dead entries.
      if (found.length !== list.length) {
        write(found.map(function (product) { return product.handle; }));
      }
      grid.innerHTML = found.map(card).join('');
      if (empty) empty.hidden = found.length > 0;
    });
  }

  function init() {
    syncButtons();
    renderGrid();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
